import { addMinutes, format, isAfter } from 'date-fns';
import { useAppSelector } from 'shared/lib/store';
import {
	selectOrderBookingData,
	selectOrderDetail,
	useOrderState,
} from 'entities/orders';

export const useBookingTimeExpired = () => {
	const bookingData = useAppSelector(selectOrderBookingData);
	const orderDetail = useAppSelector(selectOrderDetail);
	const { isWaitingList } = useOrderState(orderDetail);

	const formatedTime = () => {
		return bookingData?.dt_start
			? format(bookingData.dt_start, 'yyyy-MM-dd HH:mm')
			: null;
	};

	const isBookingTimeExpired = () => {
		const datePassed = bookingData?.dt_start
			? isAfter(
					addMinutes(new Date(), -15).toISOString(),
					bookingData.dt_start,
			  )
			: false;

		return isWaitingList && datePassed && formatedTime();
	};

	return { isBookingTimeExpired, formatedTime };
};
